module.exports = __webpack_public_path__ + "static/media/snapscan.2b399007.svg";